import { cn } from '@/lib/cn';

export type BarSegment = { key: string; value: number; color: string; label?: string };

/** Proportional segments in one bar (today by project, share of week). Empty when total is 0. */
export function StackedBar({ segments, height = 8, className }: { segments: BarSegment[]; height?: number; className?: string }) {
  const total = segments.reduce((s, x) => s + x.value, 0);
  return (
    <div className={cn('flex w-full overflow-hidden rounded-pill bg-track', className)} style={{ height }} role="img"
      aria-label={segments.map((s) => `${s.label ?? s.key}: ${Math.round((s.value / (total || 1)) * 100)}%`).join(', ')}>
      {total > 0 && segments.filter((s) => s.value > 0).map((s) => (
        <div key={s.key} style={{ width: `${(s.value / total) * 100}%`, background: s.color }} className="h-full first:rounded-l-pill last:rounded-r-pill" />
      ))}
    </div>
  );
}

/** Single-value progress (timer bar style, task estimate). */
export function ProgressBar({ value, color, height = 6, className }: { value: number; color: string; height?: number; className?: string }) {
  return (
    <div className={cn('w-full overflow-hidden rounded-pill bg-ring-track', className)} style={{ height }}>
      <div className="h-full rounded-pill" style={{ width: `${Math.min(100, Math.max(0, value * 100))}%`, background: color, transition: 'width .2s linear' }} />
    </div>
  );
}
